"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.logger = void 0;

var _realUserMonitoring = require("@eventbrite/real-user-monitoring");

// Sentry Cloud (o375540.ingest.sentry.io) decommissioned June 2026
// logger.error reports to Datadog RUM so ErrorBoundary componentDidCatch errors remain visible
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var noop = function noop() {};

var logger = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  error: function error(exception) {
    try {
      for (var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        rest[_key - 1] = arguments[_key];
      }

      (0, _realUserMonitoring.addCustomRUMError)(exception instanceof Error ? exception : new Error(String(exception)), {
        extra: rest
      });
    } catch (_unused) {// silent fail
    }
  },
  warn: noop,
  info: noop
};
exports.logger = logger;
var _default = logger;
exports.default = _default;
//# sourceMappingURL=index.js.map